module.exports = __webpack_public_path__ + "static/media/doclad15.51e72c7a.pdf";